@if (typeSign() !== 'none') {
    <div
        class="bazis-step__sign"
        part="sign"
        [class.bh-hidden]="signHidden()"
    >
        @if (typeSign() === 'icon') {
            <bazis-icon
                [icon]="iconSign()"
                size="regular"
            ></bazis-icon>
        }
        <slot name="sign"></slot>
    </div>
}

<div
    class="bazis-step__label"
    part="label"
    [class.bazis-step__label_another]="signHidden()"
>
    <slot name="label"></slot>
</div>
<slot></slot>
